import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-row-actions` component represents a group row actions.
 */
export class ChGridRowActions {
    constructor() {
        this.showOnRowHover = undefined;
        this.showOnRowActions = undefined;
        this.showOnRowContext = undefined;
    }
    window;
    mousePosition;
    /**
     * Event emitted when row actions is opened.
     */
    rowActionOpened;
    /**
     * Opens the row actions on row hover.
     */
    async openRowHover(row) {
        this.rowActionOpened.emit();
        this.window.container = row;
        this.window.xAlign = "inside-end";
        this.window.yAlign = "center";
        this.window.closeOnOutsideClick = false;
        this.window.hidden = false;
    }
    /**
     * Opens the row actions on the row-actions-button cell.
     */
    async openRowActions(cell) {
        this.rowActionOpened.emit();
        this.window.container = cell;
        this.window.xAlign = "outside-start";
        this.window.yAlign = "outside-end";
        this.window.closeOnOutsideClick = true;
        this.window.closeOnEscape = true;
        this.window.hidden = false;
    }
    /**
     * Opens the row actions on the row-actions-button cell.
     */
    async openRowContext(clientX, clientY) {
        const eventInfo = this.rowActionOpened.emit();
        if (!eventInfo.defaultPrevented) {
            this.window.hidden = true;
            this.mousePosition.style.top = `${clientY}px`;
            this.mousePosition.style.left = `${clientX}px`;
            this.mousePosition.hidden = false;
            this.window.container = this.mousePosition;
            this.window.xAlign = "outside-end";
            this.window.yAlign = "outside-end";
            this.window.closeOnOutsideClick = true;
            this.window.closeOnEscape = true;
            this.window.hidden = false;
        }
    }
    /**
     * Closes the row actions window.
     */
    async close() {
        this.window.hidden = true;
        this.mousePosition.hidden = true;
    }
    render() {
        return (h(Host, { slot: "row-actions" }, h("ch-window", { ref: el => (this.window = el), xAlign: "inside-end", modal: false, showHeader: false, showFooter: false, exportparts: "mask,window,header,caption,close,main,footer" }, h("slot", null)), h("div", { class: "mouse-position", hidden: true, ref: el => (this.mousePosition = el) })));
    }
    static get is() { return "ch-grid-row-actions"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-row-actions.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-row-actions.css"]
        };
    }
    static get properties() {
        return {
            "showOnRowHover": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates to show row actions when hovering over row."
                },
                "attribute": "show-on-row-hover",
                "reflect": true
            },
            "showOnRowActions": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates that the row actions are displayed when the row-actions-button is pressed."
                },
                "attribute": "show-on-row-actions",
                "reflect": true
            },
            "showOnRowContext": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates that the row actions are displayed when right-clicks on the row."
                },
                "attribute": "show-on-row-context",
                "reflect": true
            }
        };
    }
    static get events() {
        return [{
                "method": "rowActionOpened",
                "name": "rowActionOpened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when row actions is opened."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "openRowHover": {
                "complexType": {
                    "signature": "(row: HTMLElement) => Promise<void>",
                    "parameters": [{
                            "name": "row",
                            "type": "HTMLElement",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "HTMLElement": {
                            "location": "global",
                            "id": "global::HTMLElement"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Opens the row actions on row hover.",
                    "tags": []
                }
            },
            "openRowActions": {
                "complexType": {
                    "signature": "(cell: HTMLElement) => Promise<void>",
                    "parameters": [{
                            "name": "cell",
                            "type": "HTMLElement",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "HTMLElement": {
                            "location": "global",
                            "id": "global::HTMLElement"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Opens the row actions on the row-actions-button cell.",
                    "tags": []
                }
            },
            "openRowContext": {
                "complexType": {
                    "signature": "(clientX: number, clientY: number) => Promise<void>",
                    "parameters": [{
                            "name": "clientX",
                            "type": "number",
                            "docs": ""
                        }, {
                            "name": "clientY",
                            "type": "number",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Opens the row actions on the row-actions-button cell.",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Closes the row actions window.",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=ch-grid-row-actions.js.map
